module.exports = __webpack_public_path__ + "img/icone_studio_industriemedical-1.3e152dfc.png";